import H5Config from '@/config';

/**
 * 获取当前语言
 * @return {String} 当前语言
 */
export const getLanguage = () => {
  let localeLan = 'en';
  try {
    const langStr = (navigator.language || navigator.browserLanguage).toLowerCase();
    if (langStr.indexOf('zh-cn') > -1 || langStr.indexOf('zh') > -1) {
      localeLan = 'cn';
    }
  } catch (e) {}
  return localeLan;
};

export const getBrowserLang = () => {
  let lang;
  const navigatorLang = (navigator.language || navigator.browserLanguage).toLowerCase();
  if (navigatorLang.includes('zh')) {
    lang = ['zh-cn', 'zh-sg'].includes(navigatorLang) ? 'zh-cn' : 'zh-tw';
  } else {
    lang = navigatorLang.slice(0, 2);
  }
  // 如果不支持，英文兜底
  if (!H5Config.SUPPORT_BROWSER_LANG.includes(lang)) {
    lang = 'en';
  }
  return lang;
};

export const getCloudLang = function () {
  const lang = getBrowserLang();
  return H5Config.BROWSER_LANG_TO_CLOUD_LANG_RULE[lang] ? H5Config.BROWSER_LANG_TO_CLOUD_LANG_RULE[lang] : lang;
};

export function getUrlParams(name) {
  const search = window.location.search;
  const pattern = new RegExp('[?&]' + name + '=([^&]+)', 'g');
  let matcher = null;
  let items = '';
  try {
    matcher = pattern.exec(decodeURIComponent(search));
  } catch (e) {
    console.error(e);
  }
  if (matcher) {
    items = matcher[1];
  }
  return items;
}
